import React from "react";
import BookingTicket from "./components/ConfirmationStep/BookingTicket";
import {  useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import LoaderOverlay from "../../layout/components/LoaderOverlay";
import { Trans } from "react-i18next";
import { Typography } from "@mui/material";
import SoftSignupPrompt from "../../account/components/SoftSignupPrompt";

interface ConfirmationStepProps {
  onAddAnotherEquipment: () => void;
}

function ConfirmationStep({ onAddAnotherEquipment }: ConfirmationStepProps) {
  const reservations = useSelector(
    (state: RootState) => state.bookingCreation.reservations
  )!;
  const location = useSelector(
    (state: RootState) => state.bookingCreation.selectedLocation
  )!;
  const isLoading = !(location && reservations.length > 0);

  return (
    <>
      {isLoading ? (
        <LoaderOverlay open={isLoading} />
      ) : (
        <div className="flex flex-col h-full">
          <div className="flex-grow overflow-y-scroll no-scrollbar">
            <BookingTicket
              location={location.name}
              reservations={reservations}
              amount={1}
            />
            <div
              className="bg-[#EDF0F5] text-gray-800 p-2 rounded-lg m-5"
            >
              <Typography>
                <Trans
                  i18nKey={"book_location.confirmation.note"}
                  components={{
                    bold: (
                      <span
                        style={{
                          fontWeight: "bold",
                        }}
                      ></span>
                    ),
                  }}
                />
              </Typography>
            </div>
            <SoftSignupPrompt />
          </div>
        </div>
      )}
    </>
  );
}

export default ConfirmationStep;
